import { render } from "./LacosteHome.vue?vue&type=template&id=0bbd6933&scoped=true"
import script from "./LacosteHome.vue?vue&type=script&lang=js"
export * from "./LacosteHome.vue?vue&type=script&lang=js"

import "./LacosteHome.vue?vue&type=style&index=0&id=0bbd6933&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bbd6933"]])

export default __exports__